import angular from 'angular';
import './principal-acquittal.css';

class PrincipalAcquittalCtrl {
    /* @ngInject */
    constructor(PrincipalSvc, $location, $state, AuthSvc, logger, PRINCIPAL, CompanyService) {
        this.PrincipalSvc = PrincipalSvc;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.PRINCIPAL = PRINCIPAL;
        this.CompanyService = CompanyService;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.isSubmitting = false;
        this.principal = angular.copy(this.principal);
        this.acquittalStatuses = this.PRINCIPAL.acquittalStatuses;
        this.acquittalStatusesByFormat = {
            default: this.acquittalStatuses.filter(s => s.formats.includes('default')),
            cdar: this.acquittalStatuses.filter(s => s.formats.includes('cdar')),
        };
        this.selectedStatusesRE = new Set();
        this.selectedStatusesEM = new Set();
        this.selectedLegalStatusesEM = new Set();
        this.selectedLegalStatusesRE = new Set();
        this.isDOCL = this.principal.detail.profilBuyer;
        this.isDOFO = this.principal.detail.profilSeller;
        this.resetoffresApiConfig = angular.copy(this.offresApiConfig);
        this.getAcquittal();
        this.legalAcquittal = {};
        this.setActiveTab();
        this.criteria = {principalId: this.principal.detail.id, companyCountry: null};
        this.legalEntityList = this.CompanyService.searchByCriterias(this.criteria);
        this.resetLegalAcquittalConfig = angular.copy(this.legalAcquittal);
    }

    setActiveTab() {
        if (this.isDOCL) {
            this.activeTab = 'entrant';
        } else if (this.isDOFO) {
            this.activeTab = 'sortant';
        }
    }

    getAcquittal() {
        this.PrincipalSvc.getAcquittal(this.PrincipalSvc.getPrincipalId()).then(
            data => {
                this.acquittal = data;

                this.resetAcquittalConfig = angular.copy(this.acquittal);
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }

    isCdarFormat(format) {
        const CDAR_FORMATS = ['cdar_re', 'cdar_afnor_re', 'cdar_em', 'cdar_afnor_em'];
        return CDAR_FORMATS.includes(format);
    }

    getAcquittalStatuses(format) {
        const formatKey = this.isCdarFormat(format) ? 'cdar' : 'default';
        return this.acquittalStatusesByFormat[formatKey];
    }

    onFormatChange(acquittal, format, statusesKey, selectedStatuses) {
        const allowed = this.getAcquittalStatuses(acquittal[format] || '').map(s => s.key);
        (acquittal[statusesKey] || []).forEach(s => selectedStatuses.add(s));
        acquittal[statusesKey] = Array.from(selectedStatuses).filter(s => allowed.includes(s));
    }

    onFormatChangeRe() {
        this.onFormatChange(this.acquittal, 'format_re', 'statuses_re', this.selectedStatusesRE);
    }

    onFormatChangeEm() {
        this.onFormatChange(this.acquittal, 'format_em', 'statuses_em', this.selectedStatusesEM);
    }

    onLegalFormatChangeRe() {
        this.onFormatChange(this.legalAcquittal, 'format_re', 'statuses_re', this.selectedLegalStatusesRE);
    }

    onLegalFormatChangeEm() {
        this.onFormatChange(this.legalAcquittal, 'format_em', 'statuses_em', this.selectedLegalStatusesEM);
    }

    searchCompanies() {
        this.criteria.companyCountry = null;
    }

    defaultFormat(typeLabel, isDo) {
        if (this.acquittal[`format_${typeLabel}`] == null && isDo) {
            this.acquittal[`format_${typeLabel}`] = `ack_demat_${typeLabel}`;
        } else if (this.acquittal[`format_${typeLabel}`] == null && !isDo) {
            this.legalAcquittal[`format_${typeLabel}`] = `ack_demat_${typeLabel}`;
        }
    }

    isEditAuthorized() {
        return this.AuthSvc.isAuthorized('CONFIGURATOR');
    }

    isAuthorizedToUpdateFormat(eid) {
        return this.isEditAuthorized() && this.resetoffresApiConfig != null && this.resetoffresApiConfig.some(
            item => item.offerApi != null && item.offerApi.eid === eid && item.active === true
        );
    }

    isAuthorizedJson(){
        return this.isAuthorizedToUpdateFormat("INVOICE_RETRIEVAL");
    }

    isAuthorizedAfnor(){
        return this.isAuthorizedToUpdateFormat("STATUS_RETRIEVAL_AFNOR");
    }

    back() {
        this.$state.go('do', {tabName: 'principal'});
    }

    cancel() {
        this.acquittal = angular.copy(this.resetAcquittalConfig);
        this.legalAcquittal = angular.copy(this.resetLegalAcquittalConfig);
        this.isSubmitting = false;
    }

    restrictToSingleSelection(fluxType) {
        if (fluxType === 'entrant') {
            if (Array.isArray(this.legalAcquittal.companyIdRE) && this.legalAcquittal.companyIdRE.length > 1) {
                // Only keep the first selected item and clear others
                this.legalAcquittal.companyIdRE = [this.legalAcquittal.companyIdRE[0]];
            }
        } else if (fluxType === 'sortant') {
            if (Array.isArray(this.legalAcquittal.companyIdEM) && this.legalAcquittal.companyIdEM.length > 1) {
                // Only keep the first selected item and clear others
                this.legalAcquittal.companyIdEM = [this.legalAcquittal.companyIdEM[0]];
            }
        }
    }

    getLegalEntityContext(companyId) {
        this.PrincipalSvc.getLegalEntityContext(companyId, this.activeTab).then(data => {
            if (this.activeTab === 'entrant') {
                this.legalCompanyIdRE = data.companyIdRE != null ? [data.companyIdRE] : [''];
                this.legalAcquittal.format_re = data.format_re;
                this.legalAcquittal.acquittal_re = data.acquittal_re;
                this.legalAcquittal.statuses_re = data.statuses_re;
            }
            if (this.activeTab === 'sortant') {
                this.legalCompanyIdEM = data.companyIdEM != null ? [data.companyIdEM] : [''];
                this.legalAcquittal.format_em = data.format_em;
                this.legalAcquittal.acquittal_em = data.acquittal_em;
                this.legalAcquittal.statuses_em = data.statuses_em;
            }
        });
    }

    send() {
        if (this.form.$valid && !this.isSubmitting) {
            this.isSubmitting = true;
            const selectedCompanyIdRE = this.legalAcquittal.companyIdRE;
            const selectedCompanyIdEM = this.legalAcquittal.companyIdEM;
            if (this.legalAcquittal.companyIdEM !== undefined && this.legalAcquittal.companyIdEM[0]) {
                this.legalAcquittal.companyIdEM = this.legalAcquittal.companyIdEM[0];
            }
            if (this.legalAcquittal.companyIdRE !== undefined && this.legalAcquittal.companyIdRE[0]) {
                this.legalAcquittal.companyIdRE = this.legalAcquittal.companyIdRE[0];
            }
            this.acquittal.idDo = this.principal.detail.id;
            this.PrincipalSvc.addAcquittal(this.acquittal, this.legalAcquittal).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, {entityName: "Le Donneur d'ordre"});
                    this.isSubmitting = false;
                    this.acquittal = data;
                    this.legalAcquittal.companyIdRE = selectedCompanyIdRE;
                    this.legalAcquittal.companyIdEM = selectedCompanyIdEM;
                },
                error => {
                    this.logger.error('error.update', error);
                    this.isSubmitting = false;
                }
            );
        }
    }
}

angular.module('app.principal').component('principalAcquittal', {
    templateUrl: require('./principal-acquittal.html'),
    controller: PrincipalAcquittalCtrl,
    bindings: {
        principal: '<',
        offresApiConfig: '<',

    },
});
